<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <div class="box">
          <b-row class="box-header">
            <h3 class="box-title" style="align-self: center;">Consolidation Sea FF Details</h3>
            <md-button
              @click="goToMain"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px ml-auto"
              >New Assignment</md-button
            >
          </b-row>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="table-responsive tableMain">
            <table id="conBooking" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr no</th>
                  <th>Assignment</th>

                  <th>Client Details</th>
                  <th>More Details</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in conSeaImportData" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td
                    @click="viewExportAirPage(item1.conSeaImportId)"
                    class="showMoreData"
                  >
                    <b>Assignment No. :</b>
                    {{ item1.conSeaImportSeries }}
                    (
                    <b>{{
                      item1.containerInfo == "FclConsolidation"
                        ? "FCL-Conso"
                        : "LCL-Conso"
                    }}</b
                    >)
                    <br />
                    <b>Raised From :</b>
                    {{ item1.EmpLoc }}
                  </td>
                  <td>
                    <b>Importer Name:</b>
                    {{ item1.importer }}
                    <br />
                    <b>Exporter Name :</b>
                    {{ item1.exporter }}
                  </td>

                  <td>
                    <b>Shipping Line :</b>
                    {{ item1.shippingLine }}
                    <br />
                    <b>Place of Receipt :</b>
                    {{ item1.valPOR }}
                    <br />
                    <b>Load Port Name :</b>
                    {{ item1.valLP }}
                    <br />
                    <b>Cargo Destuffing Location :</b>
                    {{ item1.cargoDeLoca }}
                    <br />
                    <b>Port Of Discharge :</b>
                    {{ item1.valPodLocation }}
                  </td>
                  <!-- <td>{{item1.sailDate=="" || item1.sailDate==null ?'-':item1.sailDate }}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>




<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";

import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/conSeaImport/conviewSeaImpDetails"
      );
      this.viewFFExportFCL();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      isLoading: false,

      conSeaImportData: [],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading
    CustomLoader,
  },

  computed: {},

  methods: {
    goToMain() {
      this.$sessionsStorage.set("editconSeaImportId", "");
      this.$router.push({
        path: "/conSeaImport/ffConSeaImportFcl",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportAirPage(AIR) {
      this.$sessionsStorage.set("editconSeaImportId", AIR);

      this.$router.push({
        path: "/conSeaImport/ffConSeaImportFcl",
      });
    },
    viewFFExportFCL() {
      this.isLoading = true;
      let payload = {
        view: "view",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/viewConSeaImportList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.SeaConImportDetails.length > 0) {
              this.conSeaImportData = data.SeaConImportDetails;
            }
            console.log(data);
            //   this.JqueryFun();
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
</style>




// WEBPACK FOOTER //
// conviewSeaImpDetails.vue?906ce5ae